import Usage from "sections/subscription/usage";
import MobileHeader from "components/mobile-header";
import Overview from "sections/subscription/overview";
import DashboardHeader from "components/dashboard-header";
import PageHeader from "components/page-header";
import PlanAndBilling from "sections/subscription/plan-and-billing";

const Subscription = () => {
  return (
    <div className="w-full px-4 md:px-6 lg:px-6">
      <MobileHeader />

      <PageHeader label="Subscription" />
      
      <Overview />

      {/* Section heads sat on `mb-11` with nothing under them, so each block
          floated free of its own heading. A hairline ties the two together and
          gives the page the structure it was missing. */}
      <DashboardHeader
        label={"Usage"}
        className={"mb-4 border-b border-solid border-rule pb-3 xl:max-w-[850px]"}
      />

      <Usage />

      <DashboardHeader
        label={"Plan & Billing"}
        className={"mb-4 border-b border-solid border-rule pb-3 xl:max-w-[850px]"}
      />

      <PlanAndBilling />
    </div>
  );
};

export default Subscription;